/**
 * 캐시·서비스워커를 모두 정리한 후 리로드.
 * 새 버전 배포 시 SW가 옛 chunks를 cache-first로 서빙해 SPA가 깨지는 것을 방지.
 */
export async function hardReload() {
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch {
    /* 정리 실패해도 리로드는 진행 */
  }
  window.location.reload();
}
